export const BACKEND_URL =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_HEROKU_BACKEND_URL
    : process.env.REACT_APP_LOCAL_BACKEND_URL;

export const BACKEND_URL_WS =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_HEROKU_BACKEND_URL_WS
    : process.env.REACT_APP_LOCAL_BACKEND_URL_WS;
